import * as R from 'ramda'

export const safePropEq = R.curry((propName, eqValue) =>
  R.compose(R.equals(eqValue), R.prop(propName)),
)

export const isExist = (propName) =>
  R.compose(R.not, R.anyPass([R.isNil, R.isEmpty]), R.prop(propName))

// anyExist :: Map a => [String] -> a -> Bool
export const anyExist = R.compose(R.anyPass, R.map(isExist))

export const renameKeys = R.curry((keysMap, obj) =>
  R.reduce(
    (acc, key) => R.assoc(keysMap[key] || key, obj[key], acc),
    {},
    R.keys(obj),
  ),
)
